import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import {
  DEFAULT_UI_LOCALE,
  type UiLocale,
} from '../core/contracts.js'
import enCommon from './locales/en/common.json' with { type: 'json' }
import enChat from './locales/en/chat.json' with { type: 'json' }
import enMarketing from './locales/en/marketing.json' with { type: 'json' }
import enReport from './locales/en/report.json' with { type: 'json' }
import enAdmin from './locales/en/admin.json' with { type: 'json' }
import nbCommon from './locales/nb/common.json' with { type: 'json' }
import nbChat from './locales/nb/chat.json' with { type: 'json' }
import nbMarketing from './locales/nb/marketing.json' with { type: 'json' }
import nbReport from './locales/nb/report.json' with { type: 'json' }
import nbAdmin from './locales/nb/admin.json' with { type: 'json' }

export const I18N_NAMESPACES = ['common', 'chat', 'marketing', 'report', 'admin'] as const

const resources = {
  en: {
    common: enCommon,
    chat: enChat,
    marketing: enMarketing,
    report: enReport,
    admin: enAdmin,
  },
  nb: {
    common: nbCommon,
    chat: nbChat,
    marketing: nbMarketing,
    report: nbReport,
    admin: nbAdmin,
  },
} as const

let initialized = false

export function initI18n(locale: UiLocale = DEFAULT_UI_LOCALE): typeof i18n {
  if (initialized) {
    if (i18n.language !== locale) {
      void i18n.changeLanguage(locale)
    }
    return i18n
  }

  void i18n.use(initReactI18next).init({
    resources,
    lng: locale,
    fallbackLng: DEFAULT_UI_LOCALE,
    defaultNS: 'chat',
    ns: [...I18N_NAMESPACES],
    interpolation: { escapeValue: false },
    returnNull: false,
  })

  initialized = true
  return i18n
}

export { i18n }

export function chatKey(key: string): string {
  return key
}
